import { Video } from "lucide-react";
import { useStore } from "zustand";
import { Button } from "@/components/ui/button";
import { uiStore } from "@/lib/stores/ui-store";

export function VoiceStatus() {
	const activeChannel = useStore(uiStore, (state) => state.activeChannel);
	const room = useStore(uiStore, (state) => state.room);
	const navigate = useStore(uiStore, (state) => state.navigate);

	if (!activeChannel) {
		return null;
	}

	if (!room) {
		return null;
	}

	return (
		<div className="mx-2 rounded-lg border bg-card p-3">
			<Button
				className="!px-1 h-auto w-full justify-start gap-2 py-1.5"
				onClick={() => navigate({ type: "voiceChannel" }, { newTab: true })}
				variant="ghost"
			>
				<Video className="size-3.5 text-green-500" />
				<div className="flex flex-1 items-center justify-between overflow-hidden">
					<p className="truncate font-medium text-sm">{activeChannel.name}</p>
					<span className="whitespace-nowrap rounded bg-green-500/20 px-1.5 py-0.5 font-medium text-green-500 text-xs">
						CONNECTED
					</span>
				</div>
			</Button>
		</div>
	);
}
